module.exports = __webpack_public_path__ + "media/audio8.2a39ee27.mp3";